import React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import ContactBusinessSelect from 'pages/contacts/contact-business-select'
import ContactListChange from 'pages/contacts/contact-list-change'
import ImportAddList from 'pages/contacts/import-add-list'

const mapStateToProps = (state: State): any => ({
  form: state.forms.listForm,
})

class ListDialog extends React.Component<{
  form: State['forms']['listForm']
}> {
  render() {
    const { form } = this.props

    if (form.step === 'LIST_MODAL_3_BUSINESSES') {
      return <ContactBusinessSelect />
    }

    if (form.step === 'LIST_MODAL_4_MANAGE_LISTS') {
      if (form.mode === 'MULTIPLE_LISTS') {
        return <ContactListChange />
      } else if (form.mode === 'SINGLE_LIST') {
        return <ImportAddList />
      }
    }

    return null
  }
}

export default connect(mapStateToProps)(ListDialog) as any
